import { render } from "./SliderComponent.vue?vue&type=template&id=1959375d&scoped=true"
import script from "./SliderComponent.vue?vue&type=script&lang=js"
export * from "./SliderComponent.vue?vue&type=script&lang=js"

import "./SliderComponent.vue?vue&type=style&index=0&id=1959375d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1959375d"]])

export default __exports__